import axios from 'axios';
import { Toast } from 'vant';

const server = axios.create();
server.interceptors.request.use(handleRequest, handleError);
server.interceptors.response.use(handleResponse, handleError);

function handleRequest(config) {
  const authToken = window.localStorage.getItem('authToken');
  if (authToken) {
    config.headers.authToken = authToken;
  }
  return config;
}

function handleResponse(response) {
  return response;
}

function handleError(error) {
  const data = error.response && error.response.data;
  const message = (data && data.message) || error.message || '网络繁忙';
  Toast.fail(message);
  return Promise.reject(error);
}

export default server;
